import { TIME_RANGE_OPTIONS } from './constants';
import { ITimeRangeOption } from './types';
import { Button } from './components/Button';

export interface TimeRangeProps {
  activeRange: number;
  onChange: (value: number) => void;
}

export const TimeRange = (props: TimeRangeProps) => {
  const { onChange, activeRange } = props;

  const onClickHandler = (item: ITimeRangeOption) => {
    if (onChange) {
      onChange(item.value);
    }
  };

  return (
    <div className='c-time-range flex gap-3 max-[390px]:grid max-[390px]:grid-cols-2'>
      {TIME_RANGE_OPTIONS.map((item) => (
        <Button
          key={item.label}
          text={item.label}
          onClick={() => onClickHandler(item)}
          isActive={activeRange === item.value}
        />
      ))}
    </div>
  );
};
